import React from 'react';
import { Smartphone, BatteryWarning, ShieldAlert } from 'lucide-react';
export function AgitationSection() {
  const painPoints = [{
    icon: <Smartphone className="w-6 h-6 text-warm-accent" data-id="element-1" />,
    title: 'La Agresividad Digital',
    description: 'El berrinche instantáneo al apagar la pantalla.'
  }, {
    icon: <BatteryWarning className="w-6 h-6 text-warm-accent" data-id="element-2" />,
    title: 'El Agotamiento Familiar',
    description: 'Tu garganta duele de gritar y tu paciencia está al límite.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-warm-accent" data-id="element-3" />,
    title: 'El Peso del Rol de Policía',
    description: 'Sentir que solo das órdenes en lugar de disfrutar de tus hijos.'
  }];
  return <section className="py-12 px-4 bg-white" data-id="element-4">
      <div className="max-w-3xl mx-auto" data-id="element-5">
        <div className="text-center mb-10" data-id="element-6">
          <h2 className="text-2xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-7">
            Las 7:00 PM no deberían ser una zona de guerra
          </h2>
        </div>

        <div className="flex flex-col gap-4" data-id="element-8">
          {painPoints.map((point, index) => <div key={index} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.04)] flex items-start gap-4 transition-transform hover:-translate-y-1 duration-300" data-id="element-9">
              <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-10">
                {point.icon}
              </div>
              <div data-id="element-11">
                <h3 className="text-lg font-bold text-deep-blue mb-1" data-id="element-12">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-13">
                  {point.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}